export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'win'
    },
    setting: {
        logic: []
    },
    options: {
        win: 'Win',
        loss: 'Loss',
        untracked: 'Untracked'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Play Outcome',
        category: ['User', 'Plays'],
        description: 'Whether play was won, lost, or had no win/loss tracked.',
        summarise: {
            template: {
                win: 'Play was won',
                loss: 'Play was lost',
                untracked: 'Play has no win/loss tracked'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['play.outcome']
    }
}
